import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { piIconLock, piIconPencil } from '@predictiveindex/pi-client-icons';
import {
    TapestryButtonModule,
    TapestryIconButtonModule,
    TapestryIconModule,
    TapestryIconRegistryService,
    TapestrySelectModule,
    TapestrySpinnerModule,
    TapestryToggleModule
} from '@predictiveindex/tapestry';
import { CoreUiModule, DirectivesModule, TooltipModule } from '../core-ui';
import { AvatarProfileModule } from '../core-ui/global-nav/avatar-profile/avatar-profile.module';
import { EditAvatarModule } from '../core-ui/global-nav/edit-avatar/edit-avatar.module';
import { PatternInsightsModule } from '../pattern-insights';
import { SkipOrLaunchBaModule } from '../skip-or-launch-ba';
import { TranslationsModule } from '../translations';
import { MyBaProfileComponent } from './my-ba-profile/my-ba-profile.component';
import { MyInfoComponent } from './my-info/my-info.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyProfilePersonInfoComponent } from './my-profile-person-info/my-profile-person-info.component';
import { MyProfileTooltipPendingComponent } from './my-profile-tooltip-pending/my-profile-tooltip-pending.component';
import { MyProfileTooltipPersonSnapshotComponent } from './my-profile-tooltip-person-snapshot.component';
import { MyProfileTooltipComponent } from './profile-tooltip/my-profile-tooltip.component';
import { UsersAndBaReportsComponent } from './users-and-ba-reports/users-and-ba-reports.component';

@NgModule({
    imports: [
        CommonModule,
        CoreUiModule,
        TooltipModule,
        DirectivesModule,
        FormsModule,
        SkipOrLaunchBaModule,
        PatternInsightsModule,
        TapestryIconModule,
        EditAvatarModule,
        TranslationsModule,
        ReactiveFormsModule,
        TapestryButtonModule,
        TapestryIconButtonModule,
        TapestrySelectModule,
        AvatarProfileModule,
        TapestrySpinnerModule,
        TapestryToggleModule
    ],
    declarations: [
        MyProfileTooltipComponent,
        MyProfilePersonInfoComponent,
        MyProfileTooltipPendingComponent,
        MyProfileTooltipPersonSnapshotComponent,
        MyBaProfileComponent,
        UsersAndBaReportsComponent,
        MyProfileComponent,
        MyInfoComponent
    ],
    exports: [
        MyProfileTooltipComponent,
        MyBaProfileComponent,
        UsersAndBaReportsComponent,
        MyProfileComponent
    ]
})
export class MyProfileTooltipModule {
    constructor(private iconRegistryService: TapestryIconRegistryService) {
        iconRegistryService.registerIcons([piIconPencil, piIconLock]);
    }
}
